import { useSnackbar } from 'notistack';
import React from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useParams } from 'react-router-dom';
import DenseAppBar from '../../components/AppBar';
import Filters from '../../components/Filters'
import PaginationControlled from '../../components/Pagination';
import Placeholder from '../../components/Skeleton';
import { Reducers } from '../../Interfaces/Interfaces';
import { getAgentDetails } from '../../redux/actions/AgentActions';
import { getAgentTellers } from '../../redux/actions/TellerActions';
import PrimaryTheme from '../../Themes/Primary'

export default function AgentTellers() {
  const alert = useSelector((state: Reducers) => state.alert);
  const tellers = useSelector((state: Reducers) => state.tellers);
  const agentDetails = useSelector((state: Reducers) => state.agentDetails);


  const dispatch = useDispatch();
  const history = useHistory();
  const params: any = useParams();
  const { enqueueSnackbar } = useSnackbar();

  const [searchState, setSearchState] = React.useState('');

  const [page, setPage] = React.useState(0);
  const [pageSize, setPageSize] = React.useState(10);

  let list = tellers && tellers.items;

  const filter = {};
  const paginationConfig = {
    page: page + 1,
    pageSize,
    id: params.id,
    whereCondition: Object.entries(filter).length !== 0 ? JSON.stringify(filter) : "%7B%7D"
  }

  const getIndexSeed = (index: number) => {
    paginationConfig.page = page + 1;
    return (paginationConfig.page - 1) * paginationConfig.pageSize + index + 1;
  }

  const handleChange = (event: React.ChangeEvent<unknown>, value: number) => {
    setPage(value);
  };

  const handlePageSizeChange = (event: React.MouseEvent<HTMLButtonElement> | null, value: any) => {
    setPageSize(value.props.value);

    paginationConfig.pageSize = value.props.value;
    dispatch(getAgentTellers(paginationConfig));
  };

  const handleRefresh = () => {
    dispatch({
      type: 'LOADING',
      payload: true
    });
    dispatch(getAgentTellers(paginationConfig));
  }

  React.useEffect(() => {
    dispatch({
      type: 'LOADING',
      payload: true
    });

    dispatch(getAgentTellers(paginationConfig));
    dispatch(getAgentDetails(params.id));

    return () => {
      dispatch({
        type: "tellers",
        payload: {}
      });
      dispatch({
        type: "DASHBOARD",
        payload: {}
      });
    }


    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, page]);

  React.useEffect(() => {
    if (Object.entries(alert).length !== 0) {
      if (!alert.successful) {
        // display error message
        enqueueSnackbar(alert.message, { variant: "error" });

        dispatch({
          type: 'LOADING',
          payload: false
        })

        dispatch({
          type: 'ALERT',
          payload: {}
        });

      } else {

        handleRefresh();

        dispatch({
          type: 'LOADING',
          payload: false
        })

        dispatch({
          type: 'ALERT',
          payload: {}
        });
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, enqueueSnackbar, alert, history]);

  return (
    <React.Fragment>
      <div className="col-md-11 mr-auto ml-auto p-0" style={{
        height: 'auto',
        position: "relative",
      }}>
        <DenseAppBar
          canGoBack
          onClick={() => history.goBack()}
        />
      </div>
      <div className='col-md-12 pl-0 pr-0' style={{
        // overflow: "auto",
        backgroundColor: PrimaryTheme.white,
        // height: '100vh',
      }}>

        <div className="col-md-11 ml-auto mr-auto p-0" style={{
          backgroundColor: PrimaryTheme.white,
          height: '100vh',
          position: 'relative',
        }}>
          <h1 className="mb-5 transaction-agent-title" style={{
            fontFamily: PrimaryTheme.fonts?.MediumFont,
            textTransform: "uppercase",
            fontSize: PrimaryTheme.fontSizes?.subtitle
          }}>Agent {'>'} Tellers</h1>

          {/* cards  */}
          <div className="row">
            <div className="col" style={{
              height: 'auto',
              position: "relative",
            }}>
              <h5 className="text-uppercase small-subtitle" style={{
                color: PrimaryTheme.primary
              }}>Total</h5>
              <h3 className="text-uppercase text-bold mb-0 small-subtitle" style={{
                color: PrimaryTheme.dark,
                fontFamily: PrimaryTheme.fonts?.MediumFont
              }}>{agentDetails.numberOfTellers ? agentDetails.numberOfTellers : 0}</h3>
            </div>


          </div>

          <div className="row mb-5">
            <div className="col-md-12">
              <Filters
                hasSearch
                searchState={searchState}
                handleSearch={(e: any) => setSearchState(e.target.value)}
              />
            </div>
          </div>

          <div className="row ">
            <div className="col-md-12 mb-3">
              {list ? (
                <React.Fragment>
                  <div className="table-responsive">
                    <table className="table table-hover">
                      <thead className="thead-primary">
                        <tr className="text-center">
                          <th scope="col">S/N</th>
                          <th scope="col">Name</th>
                          <th scope="col">Teller ID</th>
                          {/* <th scope="col">Total Transactions</th> */}
                          <th scope="col">Location</th>

                        </tr>
                      </thead>
                      <tbody>
                        {list.length !== 0 && list?.map((item: any, index: number) => (
                          <tr key={index} className="text-center">
                            <th scope="row">{getIndexSeed(index)}</th>
                            <td >
                              {item.firstName ? item.firstName : "-"}  {item.lastName ? item.lastName : ""}
                            </td>
                            <td>{item.tellerId ? item.tellerId : "-"}</td>
                            {/* <td>{item.totalTransactions ? item.totalTransactions : 0}</td> */}
                            <td>{item.lga ? item.lga : "-"}/{item.state ? item.state : ""}</td>
                            {/* <td>
                              {item.planStatus === "Pending" && <span className="badge badge-pill badge-warning p-2 pl-3 pr-3 mr-1">{item.planStatus}</span>}
                              {item.planStatus === "Behind" && <span className="badge badge-pill badge-danger p-2 pl-3 pr-3 mr-1">{item.planStatus}</span>}
                              {item.planStatus === "On Track" && <span className="badge badge-pill badge-success p-2 pl-3 pr-3 mr-1">{item.planStatus}</span>}

                            </td> */}

                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>

                  {list.length === 0 &&
                    <React.Fragment>
                      <p className='text-center mt-3 text-dark w-100'>No result</p>
                    </React.Fragment>

                  }

                  <div className='col-md-12 p-0'>
                    {tellers.total > pageSize && <PaginationControlled onPageSizeChange={handlePageSizeChange} onChange={handleChange} page={page} total={tellers.total && tellers.total} pageSize={pageSize} />}
                  </div>
                </React.Fragment>
              ) : (
                <React.Fragment>
                  <div className="col-md-12 text-center">
                    <Placeholder variant="text" width={'100%'} height={50} animation='wave' className="display-inline" />
                  </div>
                  <div className="col-md-12 text-center">
                    <Placeholder variant="text" width={'100%'} height={50} animation='wave' className="display-inline" />
                  </div>
                  <div className="col-md-12 text-center">
                    <Placeholder variant="text" width={'100%'} height={50} animation='wave' className="display-inline" />
                  </div>

                </React.Fragment>
              )}
            </div>
          </div>
        </div>

      </div>
    </React.Fragment>
  )
}

